exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media print{\n    /*@page {\n        size: landscape;\n    }*/\n#highcharts-canvas[data-v-02388e83] {\n        width: 2300;\n}\n.card[data-v-02388e83] {\n        background-color: transparent;\n        border: none;\n}\n}\n", ""]);

// exports
